import { createStyles, DialogContent, DialogContentText, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';

interface DialogContentListProps {
  itemsList: string[];
  templateType: 'Template' | 'Block';
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContent: {
      padding: theme.spacing(1, 4, 0, 4),
    },
    itemsList: {
      color: theme.palette.text.secondary,
    },
  }),
);

export const DialogContentList = ({ itemsList, templateType }: DialogContentListProps) => {
  const classes = useStyles();

  const bodyCopy =
    templateType === 'Block'
      ? 'The following Template Blocks already exist. Would you like to create new Template Blocks or overwrite existing Template Blocks?'
      : 'The following Templates already exist. Would you like to create new Templates or overwrite existing Templates?';

  return (
    <DialogContent className={classes.dialogContent}>
      <DialogContentText id="alert-dialog-items-list" data-testid="alert-dialog-items-list">
        {bodyCopy}
      </DialogContentText>
      <ul>
        {itemsList.map((item, index) => (
          <li key={index} className={classes.itemsList}>
            <Typography variant="body2">{item}</Typography>
          </li>
        ))}
      </ul>
    </DialogContent>
  );
};
